import { useMedplum } from '@medplum/react'
import { useQuery } from '@tanstack/react-query'
import { config } from '@/config'

export function useSentFaxContent(messageId: string, attachmentId?: string) {
  const medplum = useMedplum()

  return useQuery({
    queryKey: ['sent-fax-content', messageId, attachmentId],
    enabled: !!attachmentId,
    queryFn: async () => {
      const baseUrl = config.middlewareUrl || ''
      const res = await fetch(`${baseUrl}/order/sent-faxes/${messageId}/content/${attachmentId}`, {
        headers: { Authorization: `Bearer ${medplum.getAccessToken()}` },
      })

      if (!res.ok) throw new Error(`Failed to fetch sent fax content: ${res.status}`)

      return res.blob()
    },
  })
}
